<template>
  <div v-show="!(field.hide && field.hide())">
    <!-- <div v-if="pageMode == 'view'" :key="name" class="form-field-view"><span>{{field.label}}:</span> {{field.value}}</div> -->

    <md-field :key="name" :class="[
                  { 'md-error': hasRequirements && isInvalid },
                  { 'md-valid': hasRequirements && !isInvalid },
                  { '_uiKitInput': isUiKit },
                ]"
    >
      <label>{{ field.label }}</label>
      <!-- v-model="$vo[name].value.$model" -->
      <md-input
        :type="field.type"
        :key="name"
        :name="name"
        v-model.trim="$vo[name].$model"
        :disabled="pageMode == 'view' || pageMode == 'assignee' || field.preventEdit"
      ></md-input>
      <md-icon v-if="hasRequirements && isInvalid">clear</md-icon>
      <md-icon v-else-if="hasRequirements && !isInvalid">done</md-icon>
      <span class="md-error" v-if="!isUnique">{{ field.uniqueErrorMessage || 'This value is already in use.' }}</span>
    </md-field>
  </div>
</template>

<script>
  export default {
    name: "crud-text",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        //required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      isUiKit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {}
    },
    computed: {
      isInvalid: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length && v.$invalid) result = true;
        return result;
      },
      hasRequirements: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length) result = true;
        return result;
      },
      isUnique() {
        if (undefined == this.$vo[this.name].isUnique || this.$vo[this.name].$pending) {
          return true;
        }
        return this.$vo[this.name].isUnique;
      },
    },
    methods: {
      getV: function () {
        // if (this.$vo && this.name && this.$vo[this.name] && this.$vo[this.name].value !== 'undefined') {
        //   return this.$vo[this.name].value || false;
        if (this.$vo && this.name && this.$vo[this.name] !== 'undefined') {
            return this.$vo[this.name] || false;
        } else {
          return false;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-field span.md-error {
    opacity: 1;
    color: #f44336 !important;
  }
</style>
